import { create } from "zustand";
import { BlockBlobCommitBlockListResponse } from "@azure/storage-blob";

interface UploadState {
  uploads: Record<
    string,
    {
      progress: number;
      elapsedTime: string;
      abortController?: AbortController;
      isError: boolean;
      statusMessage: string | null;
      response?: BlockBlobCommitBlockListResponse;
      collectEventName?: string;
      startDate?: number;
      filename: string;
      fileSize: number;
    }
  >;
  setUpload: (
    id: string,
    data: Partial<UploadState["uploads"][string]>
  ) => void;
  reset: (id: string) => void;
  updateStatus: (
    id: string,
    status: { isError: boolean; statusMessage: string | null }
  ) => void;
}

export const useUploadStore = create<UploadState>((set) => ({
  uploads: {},
  setUpload: (id, data) =>
    set((state) => {
      const existing = state.uploads[id] || {
        progress: 0,
        elapsedTime: "0m 0s",
        startDate: new Date().toLocaleString(),
        isError: false,
        statusMessage: null,
        filename: "",
        fileSize: 0,
      };
      return {
        uploads: {
          ...state.uploads,
          [id]: {
            ...existing,
            ...data,
          },
        },
      };
    }),
  updateStatus: (id, { isError, statusMessage }) =>
    set((state) => ({
      uploads: {
        ...state.uploads,
        [id]: {
          ...state.uploads[id],
          isError,
          statusMessage,
        },
      },
    })),
  reset: (id) =>
    set((state) => {
      const { [id]: _, ...rest } = state.uploads;
      return { uploads: rest };
    }),
}));
